<template>
  <!-- 筛选区 -->
  <div>

  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  props: {
    config: {
      Type: Object,
      default: '请选择'
    },
  },
  created () { },
  watch: {

  },
  methods: {

  },
  mounted () {

  }
}
</script>

<style scoped="">
</style>



// WEBPACK FOOTER //
// src/components/parts/hFilter.vue